<template>
  <div class="grid gap-1">
    <label class="block leading-none" :for="id">
      {{ label }}
    </label>

    <p v-if="help || $slots.help" :id="aria['aria-describedby']" class="help text-sm text-gray-500">
      <slot v-if="$slots.help" name="help"/>
      <template v-else>
        {{ help }}
      </template>
    </p>

    <div :class="['field relative', { 'text-xl': size == 'lg' }]">
      <span v-if="prefix" class="absolute left-0 top-0 flex items-center py-2 px-3 text-gray-500">
        {{ prefix }}
      </span>

      <input
        v-model="model"
        :class="['block w-full py-2 px-3 border border-gray-300 dark:border-gray-800 placeholder:text-gray-500 rounded-md shadow-sm', {
          'text-right': type == 'number',
          'pl-7': !!prefix,
          'pr-7': !!suffix
        }]"
        :name="name"
        :type="type"
        v-bind="{ id, min, max, step, disabled, required, placeholder, pattern, ...aria }"
      >

      <span v-if="suffix" class="absolute right-0 top-0 flex items-center py-2 px-3 text-gray-500">
        {{ suffix }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { computed, useSlots } from "vue"
import { uniqueId } from "lodash-es"

const model = defineModel([Number, String])

const props = defineProps({
  id: { type: String, default: () => `input-${uniqueId()}` },
  name: String,
  type: { type: String, default: "text" },
  placeholder: String,
  pattern: String,
  disabled: Boolean,
  required: Boolean,
  min: [Number, String],
  max: [Number, String],
  step: [Number, String],
  label: String,
  help: String,
  suffix: String,
  prefix: String,
  hideLabel: Boolean,
  size: String,
})

const slots = useSlots()

const name = computed(() => props.name ?? uniqueId())

const aria = computed(() => {
  const attrs = {}

  if (props.help || slots.help) {
    attrs["aria-describedby"] = `${props.id}_help`
  }

  return attrs
})
</script>
